import React, { useState, useEffect } from 'react';
import { Box, Button, Modal, TextField, Typography } from '@mui/material';
import { addModule, updateModule } from '../../../services/adminServices/ModuleServices';
import { toast } from 'react-toastify';

function CreateModuleModal({ onClose, isOpen, editableModule, fetchModules }) {
    const [formData, setFormData] = useState({
        moduleName: '',
        moduleDetails: '',
    });

    useEffect(() => {
        if (editableModule) {
            setFormData({
                moduleName: editableModule.module_Name,
                moduleDetails: editableModule.module_Note ,
            });
        } else {
            setFormData({
                moduleName: '',
                moduleDetails: '',
            });
        }
    }, [editableModule]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        try {
            const obj = {
                module_Name: formData.moduleName,
                module_Note: formData.moduleDetails,
            };

            if (editableModule) {
                const response = await updateModule(editableModule.moduleID, obj);
                toast.success(response.data.message || 'Module updated successfully!');
            } else {
                const response = await addModule(obj);
                toast.success(response.data.message || 'Module added successfully!');
            }

            fetchModules();
            setFormData({ moduleName: '', moduleDetails: '' });
            onClose();
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'An error occurred while saving the module.';
            toast.error(errorMessage);
        }
    };

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '30%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" sx={{ mb: 2 }}>
                    {editableModule ? 'Edit Module' : 'Add New Module'}
                </Typography>
                <TextField
                    fullWidth
                    label="Module Name *"
                    name="moduleName"
                    value={formData.moduleName}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                />
                <TextField
                    fullWidth
                    label="Module Details *"
                    name="moduleDetails"
                    value={formData.moduleDetails}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                />
                <Box mt={3} textAlign="center">
                    <Button variant="contained" color="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

export default CreateModuleModal;
